import React, { FC } from 'react';

import HowBrandWorksSection from '@rover/react-lib/src/components/HowBrandWorksSection';
import {
  PageSectionId,
  useSectionRef,
} from '@rover/react-lib/src/pages/landing/SeoLocation/hooks/useSectionRef';

const HomePageHowBrandWorks: FC = () => {
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks, { threshold: 0.1 });

  return <HowBrandWorksSection py={['0x', '8x']} mt={['8x', '8x', '0x']} htmlRef={sectionRef} />;
};

export default HomePageHowBrandWorks;
